<template>
  <transition name="cookie-fade">
    <section v-if="showBanner" class="cookie-banner" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <p class="cookie-banner__text">
        Koristimo neophodne kolačiće za osnovno funkcionisanje sajta, rezervacije i bezbednu obradu plaćanja.
        Uz vašu saglasnost koristimo i funkcionalne, analitičke i marketinške kolačiće radi unapređenja
        korisničkog iskustva, analize posećenosti i prikazivanja relevantnih promocija.
        <router-link to="/legal#cookies">Pročitajte politiku kolačića</router-link>
      </p>

      <div class="cookie-banner__actions">
        <button type="button" class="cookie-btn cookie-btn--ghost" @click="openPreferences">
          Podešavanja
        </button>
        <button type="button" class="cookie-btn cookie-btn--outline" @click="rejectNonEssential">
          Odbij opcione
        </button>
        <button type="button" class="cookie-btn cookie-btn--primary" @click="acceptAll">
          Prihvati sve
        </button>
      </div>
    </section>
  </transition>
</template>

<script>
import {
  acceptAllCookies,
  cookieConsentState,
  openCookiePreferences,
  rejectNonEssentialCookies,
} from '@/utils/cookieConsent'

export default {
  name: 'CookieBanner',
  data() {
    return {
      consentState: cookieConsentState,
    }
  },
  computed: {
    showBanner() {
      return this.consentState.isReady && this.consentState.showBanner
    },
  },
  methods: {
    acceptAll() {
      acceptAllCookies()
    },
    rejectNonEssential() {
      rejectNonEssentialCookies()
    },
    openPreferences() {
      openCookiePreferences()
    },
  },
}
</script>

<style lang="scss" scoped>
.cookie-banner {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  max-width: 1360px;
  bottom: 16px;
  z-index: 100000;
  background: #ffffff;
  color: #1f2937;
  border: 1px solid #dde3ea;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(5, 16, 54, 0.16);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__text {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;

    a {
      color: #3554d1;
      text-decoration: underline;
    }
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    justify-content: flex-end;
  }
}

.cookie-btn {
  border: 1px solid transparent;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &--ghost {
    background: #f7f8fa;
    color: #1f2937;
    border-color: #dde3ea;
  }

  &--outline {
    background: #ffffff;
    color: #1f2937;
    border-color: #b8c3d1;
  }

  &--primary {
    background: #3554d1;
    color: #ffffff;
  }
}

.cookie-fade-enter-active,
.cookie-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.cookie-fade-enter,
.cookie-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, 8px);
}

@media (min-width: 992px) {
  .cookie-banner {
    width: calc(100% - 48px);
    bottom: 20px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    &__text {
      max-width: 70%;
    }

    &__actions {
      width: auto;
      flex-wrap: nowrap;
      justify-content: flex-end;
    }
  }
}
</style>
